export default "__VITE_ASSET__Dy8x_HYC__"